import A11yDialog from 'a11y-dialog';
import Pristine from 'pristinejs';
import { defaultPristineConfig } from './formControl';

export function authDialog() {
  const dialogElement = document.getElementById('auth-dialog');
  if (!dialogElement) return;

  const loginSection = dialogElement.querySelector('.auth-dialog__login');
  const signupSection = dialogElement.querySelector('.auth-dialog__signup');
  const switchSection = dialogElement.querySelectorAll('.auth-dialog__switch-section');
  const loginForm = loginSection.querySelector('form');
  const signupForm = signupSection.querySelector('form');

  const dialog = new A11yDialog(dialogElement);

  const loginPristine = new Pristine(loginForm, defaultPristineConfig);
  const signupPristine = new Pristine(signupForm, defaultPristineConfig);

  const isLoginShown = () => !loginSection.hidden;
  const isSignupShown = () => !signupSection.hidden;
  const toLogin = () => {
    loginSection.hidden = false;
    signupSection.hidden = true;
  };
  const toSignup = () => {
    signupSection.hidden = false;
    loginSection.hidden = true;
  };
  const toggleSection = () => {
    if (isLoginShown()) toSignup();
    else toLogin();
  };

  switchSection.forEach((button) => {
    button.addEventListener('click', toggleSection);
  });

  loginForm.addEventListener('submit', (e) => {
    e.preventDefault();

    if (loginPristine.validate()) {
      dialog.hide();
    }
  });

  signupForm.addEventListener('submit', (e) => {
    e.preventDefault();

    if (signupPristine.validate()) {
      dialog.hide();
    }
  });

  toLogin();

  return {
    hide: () => {
      dialog.hide();
    },
    login: () => {
      toLogin();
      dialog.show();
    },
    signup: () => {
      toSignup();
      dialog.show();
    },
  };
}
